import * as processUI from '../../ui-definition/process-ui'
import TreatmentPaymentWidgetContainer from '../../../sales-order/component/task-widget/TreatmentPaymentWidgetContainer'
import PhysicianAndSupplierWidgetContainer from '../../../customer/component/task-widget/PhysicianAndSupplierWidgetContainer'
import TreatmentQuotationWidgetContainer from '../../../treatment/component/task-widget/TreatmentQuotationWidgetContainer'
import ImplantTreatmentQuotationWidgetContainer from '../../../treatment/component/task-widget/ImplantTreatmentQuotationWidgetContainer'
import InitialHesitationWidgetContainer from "../../../sales-order/component/task-widget/InitialHesitationWidgetContainer";

export const NAME_COMPONENT_MAPPING = {
    [processUI.TREATMENT_PAYMENT_WIDGET]: TreatmentPaymentWidgetContainer,
    [processUI.PHYSICIAN_AND_SUPPLIER_WIDGET]: PhysicianAndSupplierWidgetContainer,
    [processUI.TREATMENT_QUOTATION_WIDGET]: TreatmentQuotationWidgetContainer,
    [processUI.IMPLANT_TREATMENT_QUOTATION_WIDGET]: ImplantTreatmentQuotationWidgetContainer,
    [processUI.INITIAL_HESITATION_WIDGET_CONTAINER]: InitialHesitationWidgetContainer,
}



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/name-component-mapping.js